<template>
    <div class="lb-project-box" @click="$emit('click', content)">
        <div
            :style="`${background(content.image.url)}`"
            class="lb-project-background-card"
        />
        <div class="columns is-mobile is-marginless pt-1">
            <div class="column is-11 py-0">
                <p class="is-size-6 lb-card-title has-text-left pt-3 pb-2">
                    {{ content.title }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { projectBackground } from '@/lib/helpers';
import _ from 'underscore';
export default {
    props: {
        content: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            showToolbar: false,
        };
    },
    computed: {
        background() {
            return (bg) => {
                return projectBackground(
                    !_.isEmpty(this.content.image) ? this.content.image : bg
                );
            };
        },
        community() {
            return this.$store.getters.community;
        },
    },
    methods: {},
};
</script>

<style scoped>
.level {
    padding: 0 0.5em;
}
.edit-button {
    text-shadow: 0px 2px 4px #000;
}
.lb-card-title {
    max-width: 100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
